// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2uvA1","col":"styles_col__1c_kg"};